import { render } from "./main_contact.vue?vue&type=template&id=61dcc240&scoped=true"
import script from "./main_contact.vue?vue&type=script&lang=js"
export * from "./main_contact.vue?vue&type=script&lang=js"

import "./main_contact.vue?vue&type=style&index=0&id=61dcc240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61dcc240"]])

export default __exports__